import React from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { languageSupportClick } from '../../utils/statistics/customEvents';
import { A11yLinksList, A11yListItem, A11yLink } from './AccessibilityLinks.styles';
import PropTypes from 'prop-types';

const AccessibilityLinks = ({ isVisible }) => {
    if (!isVisible) {
        return null;
    }

    const trackA11yLinkClick = (type) => {
        trackCustomEvent(languageSupportClick(type));
    };

    return (
        <A11yLinksList>
            <A11yListItem data-rt="a11y-audio-description">
                <A11yLink to="/syntolkat" onAfterClick={(e) => trackA11yLinkClick('syntolkat')}>
                    <span
                        className="svt_icon play_promotion-a11y__icon svt_icon--sight"
                        aria-hidden="true"
                    ></span>
                    Syntolkat
                </A11yLink>
            </A11yListItem>
            <A11yListItem data-rt="a11y-sign-language">
                <A11yLink to="/teckensprak" onAfterClick={(e) => trackA11yLinkClick('teckenspråk')}>
                    <span
                        className="svt_icon play_promotion-a11y__icon svt_icon--sign-language"
                        aria-hidden="true"
                    ></span>
                    Teckenspråk
                </A11yLink>
            </A11yListItem>
        </A11yLinksList>
    );
};

AccessibilityLinks.propTypes = {
    isVisible: PropTypes.bool,
};

export default AccessibilityLinks;
